import { LogoView, useLogo } from "@/modules/common/features/logo";

export function Logo() {
  const { companyName, src } = useLogo();

  return <LogoView src={src} companyName={companyName} />;
}
